import mixpanel from "mixpanel-browser";
import { FaPhone } from "react-icons/fa6";
import { FiAtSign } from "react-icons/fi";

const UnlockForCollaborationCard = ({ onUnlockClick, onCollabClick }) => {
  // const handleToastUnlock = () => {
  //     toast.dark(<>
  //         <div className="flex flex-col justify-center items-center gap-2 text-center">
  //             <div>
  //                 This information is locked. Do you want to unlock the information?
  //             </div>
  //             <button className="flex px-[10px] py-[6px] justify-center items-center gap-[10px] flex-[1_0_0] rounded-[6px] bg-[#DC2627] text-xs"
  //                 onClick={() => onButtonClick()}>
  //                 Yes I would like to unlock
  //             </button>
  //         </div>
  //     </>, {
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //     })
  // }

  return (
    <div className="flex p-[20px] flex-col items-center gap-[16px] rounded-[8px] bg-[rgba(255,_255,_255,_0.12)] [box-shadow:0px_10px_20px_0px_rgba(0,_0,_0,_0.10)]">
      <div className="flex flex-col items-center gap-[8px] self-stretch">
        <span className="text-[#FFF] text-center font-[Inter] text-[16px] not-italic font-semibold leading-[18px]">
          Ready to collaborate?
        </span>
        <span className="text-[#A3A3A3] text-center font-[Inter] text-[12px] not-italic font-normal leading-[18px]">
          Let's give your brand a boost with some creative ways & authentic
          marketing!
        </span>
      </div>
      <div
        className="flex p-[16px] justify-between items-center rounded-[8px] bg-[rgba(226,_232,_240,_0.12)] w-full cursor-pointer"
        onClick={() => onUnlockClick()}
      >
        <div className="flex flex-col items-start gap-[12px] filter blur-[3px]">
          <div className="flex items-center gap-[8px]">
            <FiAtSign size={16} color="#A7CAFF" />
            <span className="text-[#FFF] text-center font-[Inter] text-[14px] not-italic font-normal leading-[normal]">
              dummy@mail.com
            </span>
          </div>
          <div className="flex items-center gap-[8px]">
            <FaPhone size={16} color="#A7CAFF" />
            <span className="text-[#FFF] text-center font-[Inter] text-[14px] not-italic font-normal leading-[normal]">
              +91 9999999999
            </span>
          </div>
        </div>
        <div className="text-[32px]">🔒</div>
      </div>
      <button
        className="flex px-[16px] py-[8px] justify-center items-center gap-[10px] flex-[1_0_0] rounded-[6px] bg-[#DC2627] self-stretch hover:-translate-y-1 hover:scale-105 duration-300 transition ease-in-out delay-150"
        onClick={() => {
          mixpanel.track("Let's Talk! clicked on Creator Public Profile");
          onCollabClick();
        }}
      >
        <span>🫱🏼‍🫲🏽</span>
        <span className="text-[#FFF] text-[14px] not-italic font-medium leading-[24px] font-[Inter]">
          Let's Talk!
        </span>
      </button>
    </div>
  );
};

export default UnlockForCollaborationCard;
